import { render, staticRenderFns } from "./WebsiteAmenity.vue?vue&type=template&id=1c0294c3&scoped=true&"
import script from "./WebsiteAmenity.vue?vue&type=script&lang=js&"
export * from "./WebsiteAmenity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0294c3",
  null
  
)

export default component.exports